import { Component, Input, OnInit, Output } from '@angular/core';
import { Style, SpaceType } from "./hd-space.service";  

@Component({
  selector: 'hd-space',
  templateUrl: './hd-space.component.html',
  styleUrls: ['./hd-space.component.less']
})
export class HdSpaceComponent implements OnInit {
  @Input() type: SpaceType = SpaceType.row; 
  @Input() size: number; 
  @Input() background: string = 'inherit'; 

  style: Style = new Style();

  constructor() { }

  ngOnInit() {
    this.style['background'] = this.background;
    if(this.type === SpaceType.row){
      this.style['width'] = '100%';
      this.style['height'] = this.size + 'px';
    }else{
      this.style['height'] = '100%';
      this.style['width'] = this.size + 'px';
    }
  }

}
